import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import Heading from "../../../components/Heading";
import RouteTable from "./RouteTable";
import "./index.scss";
import "../index.scss";
import constants from "../../../constants/constants";
const { ROLES } = constants;
const { HO_ADMIN, DEVELOPER, ROLE_CENTRALOPERATOR, HUB_ADMIN, ROLE_FUNCTIONALHEAD, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_MD, ROLE_HOCRM } = ROLES;

const RouteMaster = () => {
  const [activeKey, setActiveKey] = useState("1");
  const [roles, setRoles] = useState();

  useEffect(() => {
    console.log("LoginRoles......" + roles?.roles);
    setRoles(JSON.parse(localStorage.getItem("userinfo")));
    const params = new URLSearchParams(window.location.search);
    const type = (params.get("type") || "").toUpperCase();
    if (type === "AIR") {
      setActiveKey("2");
    } else if (type === "SURFACE") {
      setActiveKey("1");
    }
  }, []);

  const changeTab = (key) => {
    setActiveKey(key);
  };

  return (
    <div className="p-2">
      <Heading
        title={
          roles && (
            roles?.roles?.includes(HO_ADMIN) ||
            roles?.roles?.includes(DEVELOPER) ||
            roles?.roles?.includes(ROLE_CENTRALOPERATOR) ||
            roles?.roles?.includes(ROLE_HOCRM) ||
            roles?.roles?.includes(HUB_ADMIN) ||
            roles?.roles?.includes(ROLE_FUNCTIONALHEAD) ||
            roles?.roles?.includes(ROLE_ZONALHEAD) ||
            roles?.roles?.includes(ROLE_ZONALOPERATOR) ||
            roles?.roles?.includes(ROLE_RM) ||
            roles?.roles?.includes(ROLE_MD)


          )
            ? "Shipment Routes"
            : "Vehicle Route Master"
        }
      />
      <div className="rate-card-tab-container">
        <Tabs
          activeKey={activeKey}
          onChange={changeTab}
          items={[
            {
              label: "Surface",
              key: "1",
              children: <RouteTable primaryMode="SURFACE" />,
            },
            {
              label: "Air",
              key: "2",
              children: <RouteTable primaryMode="AIR" />,
            },
          ]}
        />
      </div>
    </div>
  );
};
export default RouteMaster;
